/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Milestone_Three_MonthsInputs */

const en_us2_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three months of training`)
};

const pt_br2_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três meses de treino`)
};

const es_419_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres meses de entrenamiento`)
};

const pt_pt2_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três meses de treino`)
};

const fr_fr2_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois mois d'entraînement`)
};

const de_de2_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Monate Training`)
};

const it_it2_milestone_three_months = /** @type {(inputs: Milestone_Three_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre mesi di allenamento`)
};

/**
* | output |
* | --- |
* | "Three months of training" |
*
* @param {Milestone_Three_MonthsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const milestone_three_months = /** @type {((inputs?: Milestone_Three_MonthsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Milestone_Three_MonthsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_milestone_three_months(inputs)
	if (locale === "es-419") return es_419_milestone_three_months(inputs)
	if (locale === "pt-PT") return pt_pt2_milestone_three_months(inputs)
	if (locale === "fr-FR") return fr_fr2_milestone_three_months(inputs)
	if (locale === "de-DE") return de_de2_milestone_three_months(inputs)
	if (locale === "it-IT") return it_it2_milestone_three_months(inputs)
	return en_us2_milestone_three_months(inputs)
});
export { milestone_three_months as "milestone.three_months" }